import { render } from "./ZoomSlider.vue?vue&type=template&id=cc742ca2&scoped=true"
import script from "./ZoomSlider.vue?vue&type=script&lang=js"
export * from "./ZoomSlider.vue?vue&type=script&lang=js"

import "./ZoomSlider.vue?vue&type=style&index=0&id=cc742ca2&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc742ca2"]])

export default __exports__